import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAin1sfJrC9QhiwkMh-wOMIiU8ZK6poQdQ",
  authDomain: "pre-marriage-assessment.firebaseapp.com",
  projectId: "pre-marriage-assessment",
  storageBucket: "pre-marriage-assessment.firebasestorage.app",
  messagingSenderId: "622837348041",
  appId: "1:622837348041:web:fca7f81a65afeff894bf18",
  measurementId: "G-DMLKH7Z7B7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app);